export class Colors
{
	public static colors = [ '#c80d06' , '#d8b219', '#98b61d', '#2a7606']
		//alarmant, préoccupant, important, positif



		//old1 = [ 'green',  'yellow',    'orange',     'red' ];
		//old2 = [ '#9DAF40', '#c5d283', '#FFAC4D', '#B61311'];
}